import PropTypes from 'prop-types';
import React from 'react';

const ReactPropTypes = PropTypes;

class DropdownMenuItem extends React.Component {
	static propTypes = {
	  title: ReactPropTypes.string,
	  onClickItem: ReactPropTypes.func,
	  closeDropdownMenu: ReactPropTypes.func,
	};

	static defaultProps = {
	  title: '',
	  onClickItem: null,
	  closeDropdownMenu: null,
	};

	render() {
	  return (
  <a href="#" className="dropdownMenuItem" onClick={this._onClick}>
    {this.props.title}
  </a>
	  );
	}

	/**
	* Event handler for 'onClick'
	*/
	_onClick = (event) => {
	  event.preventDefault();
	  // aizver menu
	  this.props.closeDropdownMenu();
	  // izpilda vajadzīgo
	  this.props.onClickItem();
	};
}

module.exports = DropdownMenuItem;
